import script from "./LinkToParentButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkToParentButton.vue?vue&type=script&setup=true&lang=js"

import "./LinkToParentButton.vue?vue&type=style&index=0&id=cffe042e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cffe042e"]])

export default __exports__